import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 2,
  class: "submitted-consent ion-padding"
}
const _hoisted_6 = { class: "signature-preview ion-margin-top" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "consent-text" }
const _hoisted_9 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_grid, { fixed: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_buttons, { slot: "start" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      slot: "icon-only",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goBack()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, { icon: _ctx.arrowBack }, null, 8, ["icon"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_title, null, {
                  default: _withCtx(() => [
                    (_ctx.submittedConsent)
                      ? (_openBlock(), _createBlock(_component_ion_label, { key: 0 }, {
                          default: _withCtx(() => _cache[1] || (_cache[1] = [
                            _createTextVNode("Parent Consent Obtained")
                          ])),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_ion_label, { key: 1 }, {
                          default: _withCtx(() => _cache[2] || (_cache[2] = [
                            _createTextVNode("Parent/Guardian Consent")
                          ])),
                          _: 1
                        }))
                  ]),
                  _: 1
                }),
                (_ctx.submittedConsent)
                  ? (_openBlock(), _createBlock(_component_ion_buttons, {
                      key: 0,
                      slot: "end"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, { slot: "icon-only" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              slot: "end",
                              color: "success",
                              icon: _ctx.checkmarkCircle
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, {
      class: "ion-padding",
      style: {"--padding-bottom":"200px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_grid, { fixed: "" }, {
          default: _withCtx(() => [
            (_ctx.consentVideoId && _ctx.targetVideo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("a", {
                    href: _ctx.targetVideo?.link,
                    target: "_blank"
                  }, _toDisplayString(_ctx.targetVideo?.title || 'Video'), 9, _hoisted_2),
                  _createElementVNode("iframe", {
                    style: {"width":"100%","height":"380px"},
                    src: _ctx.getEmbeddedYTLink(_ctx.targetVideo?.link),
                    frameborder: "0",
                    allowfullscreen: ""
                  }, null, 8, _hoisted_3)
                ]))
              : _createCommentVNode("", true),
            (_ctx.targetEvent)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.targetEvent.name), 1),
                  _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                  _cache[4] || (_cache[4] = _createTextVNode(" on ")),
                  _createElementVNode("b", null, _toDisplayString(_ctx.targetEvent.formattedDateTime), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.submittedConsent)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("p", null, " Parent/guardian consent was submitted on " + _toDisplayString(_ctx.formatDate(_ctx.submittedConsent.createdAt)), 1),
                  _createElementVNode("div", _hoisted_6, [
                    _cache[5] || (_cache[5] = _createElementVNode("p", { class: "signature-label" }, "Parent/Guardian Signature:", -1)),
                    _createElementVNode("img", {
                      src: _ctx.submittedConsent.signatureImg || _ctx.submittedConsent.signatureDataUrl,
                      alt: "Parent's Signature",
                      class: "signature-image"
                    }, null, 8, _hoisted_7)
                  ])
                ]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("p", null, _toDisplayString(_ctx.responseByTarget), 1)
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "signature-container" }, [
                _createElementVNode("p", { class: "signature-label" }, "Parent/Guardian Signature:"),
                _createElementVNode("canvas", {
                  id: "signaturePad",
                  class: "signature-pad"
                }),
                _createElementVNode("p", null, [
                  _createTextVNode("By signing in the box, you agree to our Terms and Conditions ("),
                  _createElementVNode("a", {
                    href: "https://www.fdmt.hk/legal",
                    target: "_blank"
                  }, "fdmt.hk/legal"),
                  _createTextVNode(")")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_ion_button, {
                  color: "danger",
                  fill: "outline",
                  onClick: _ctx.clearSignature,
                  disabled: !_ctx.hasSignature
                }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode("Clear")
                  ])),
                  _: 1
                }, 8, ["onClick", "disabled"]),
                _createVNode(_component_ion_button, {
                  color: "success",
                  onClick: _ctx.saveSignature,
                  disabled: !_ctx.hasSignature
                }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode("Submit")
                  ])),
                  _: 1
                }, 8, ["onClick", "disabled"])
              ])
            ], 512), [
              [_vShow, !_ctx.submittedConsent]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}